import Input from "app/components/Input"
import Textarea from "app/components/Icons/Textarea"
import { Select } from "app/components/Select"
import React from "react"
import DatePicker from "app/components/DatePicker"
import Assignee from "../containers/Home/components/ColumnCustomize/Assignee"
import { DropdownIcon } from "app/components/Icons"
import MemberProfile from "app/components/MemberProfile"
import { useSelector } from "react-redux"
import { selectUserDetailsData } from "app/redux/selector"

export default function AddRelease() {
    const userDetail = useSelector(selectUserDetailsData);
    const defaultAssignee = {
        name: userDetail?.fullName,
        color: '',
        status: "online" as "online",
        initials: userDetail?.fullName?.split(' ').map((name: string) => name[0]).join(''),
        online: true,
    }
    return (
        <div className="flex flex-col px-[24px] py-4 pt-[12px] gap-4">
            <div className="flex flex-col gap-y-4">
                <Input
                    label="Release name"
                    placeholder="Enter release name..."
                    id='release-name'
                    inputClassName='!h-[48px] !gap-[0px]'
                    innerContainerClassName="!gap-[0px]"
                />
                <div className="grid grid-cols-2 gap-x-[10px]">
                    <DatePicker
                        label="Start date"
                        value={new Date()}
                        onChange={() => {}}
                        innerContainerClassName="!gap-[0px]"
                    />
                    <DatePicker
                        label="Release date"
                        value={new Date()}
                        onChange={() => {}}
                        innerContainerClassName="!gap-[0px]"
                        align="end"
                    />
                </div>
               <Assignee
                    dropdownTrigger={
                    defaultAssignee ? (
                        <div className="flex items-center gap-1 h-[48px] px-3 border rounded-md">
                           <MemberProfile
                            iconColor={defaultAssignee?.color ?? "#79808A"}
                            iconBgColor={"#F5F6FA"}
                            iconText={defaultAssignee?.initials ?? defaultAssignee?.name[0]}
                            name={defaultAssignee.name ?? defaultAssignee?.name[0]}
                            statusColor="#F00"
                            iconClassName="w-6 h-6"
                            />
                            <DropdownIcon size={16}/>
                        </div>
                        ) : (
                        <div>
                            <Input
                            label="Assignee"
                            placeholder="Select assignee"
                            id="assignee"
                            inputClassName="!h-[48px] !gap-[0px]"
                            innerContainerClassName="!gap-[0px]"
                            endIcon={<DropdownIcon size={16} />}
                            />
                        </div>
                        )
                    }
                    assignedTo={[]}
                    dropdownContainerClassName="max-h-[280px] overflow-scroll"
                    className="min-w-[345px]"
                    />
                <Textarea
                    label="Release description"
                    placeholder="Enter release description"
                    id='release-description'
                    inputClassName='!gap-[0px]'
                    innerContainerClassName="!gap-[0px]"
                />
            </div>
        </div>
    )
}